var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5654 1.03041C19.832 0.387219 17.9572 0.0351562 16 0.0351562C14.0429 0.0351562 12.1682 0.387219 10.4349 1.03028L9.73926 16.0352L10.4349 31.04C12.1682 31.6832 14.0429 32.0352 16 32.0352C17.9573 32.0352 19.832 31.6832 21.5654 31.0399L22.261 16.0352L21.5654 1.03041Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0353C0 22.9146 4.342 28.7794 10.4348 31.04V1.0304C4.342 3.29115 0 9.15577 0 16.0353Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0353C32 9.15577 27.658 3.29115 21.5652 1.0304V31.0401C27.658 28.7794 32 22.9146 32 16.0353Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuinea);
export default __webpack_public_path__ + "static/media/guinea.180e486f.svg";
export { ForwardRef as ReactComponent };